/**
 * @file 受取不可の場合の文言変更
 */
'use strict';
// utility class


/**
 * @classname ReceiveDateDisabledView
 * @classdesc 受取不可の場合の文言変更
 */
export default class ReceiveDateDisabledView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ReceiveDateDisabledView.constructor');
		if($e.prop('disabled')){
			console.log($e.val());
			const year = $e.val().substring(0,4);
			const month = $e.val().substring(4,6);
			const day = $e.val().substring(6);
			$e.text(`${year}年${month}月${day}日完売`);
		}
	};
}
